import { mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { LookupService } from '@admin/shared/services/lookup.service';
import { ConfigurationService } from '@admin/shared/services/configuration.service';

@Injectable()
export class SalesLookupResolveService {
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.lookupService
      .loadAllLookups()
      .pipe(mergeMap((x) => this.configurationService.loadAllConfigs()));
  }

  constructor(
    private lookupService: LookupService,
    private configurationService: ConfigurationService
  ) {}
}
